import React from 'react';

import BreadcrumbsNav from 'components/BreadcrumbsNav/BreadcrumbsNav';
import { useFormContext } from 'react-hook-form';

export const BreadCrumbs = ({ crumbs, setModalData }) => {
  const { formState } = useFormContext();
  const { isDirty } = formState;

  return (
    <BreadcrumbsNav itemsArray={crumbs} setDialogModalData={setModalData} formIsChanged={isDirty} />
  );
};
